export default __webpack_public_path__ + "static/SRF 3260ACS25 - Product Specifications & Technical Data-fd33e3ac1e03db067df159f47cbe82c8.pdf";